import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import PageMenu from '../PageMenu';
import Button from '../Button';
import '../styles/MainHeader.scss';
import logo from '../../images/logo.svg';
import i18n from '../../utils/i18n';

class MainHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuTabletsExpanded: false
    };
    this.toggleMenuExpanded = this.toggleMenuExpanded.bind(this);
  }

  toggleMenuExpanded() {
    this.setState({ menuTabletsExpanded: !this.state.menuTabletsExpanded });
  }

  render() {
    const { menuTabletsExpanded } = this.state;
    return (
      <div
        className={`main-header ${
          menuTabletsExpanded ? 'menu-tablets-expanded' : ''
        }`}
      >
        <Container>
          <Row>
            <Col lg="2" md="12" className="no-padding logo-container">
              <span onClick={this.props.routeToHome}>
                <img src={logo} alt="Deuce" />
              </span>
              <div
                className="visible-tablets right-menu-label"
                onClick={this.toggleMenuExpanded}
              >
                {menuTabletsExpanded ? (
                  <div className="close-label-wrapper">
                    <span className="close-label">
                      {i18n.t('header.CLOSE')}
                    </span>
                    <span className="close-x">X</span>
                  </div>
                ) : (
                  <FontAwesome className="bars fa-2x" name="bars" />
                )}
              </div>
            </Col>
            <Col lg="6" md="12" className="no-padding page-menu-wrapper">
              <PageMenu />
            </Col>
            <Col lg="4" md="12" className="user-sign-wrapper no-padding">
              <div>
                {this.props.isLogged ? (
                  <div className="logged-user">
                    <span className="username private-data">{this.props.userFullName}</span>
                    <Button
                      text={i18n.t('header.SIGN_OUT')}
                      onClick={this.props.signOut}
                      buttonClass="grey-button"
                    />
                  </div>
                ) : (
                  <div className="not-logged-user">
                    <Button
                      text={i18n.t('header.SIGN_IN')}
                      onClick={this.props.routeToSignIn}
                      buttonClass="grey-button sign-in-button"
                    />
                    <Button
                      text={i18n.t('header.JOIN_DEUCE')}
                      onClick={this.props.routeToJoin}
                      buttonClass="join-button"
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

MainHeader.propTypes = {
  isLogged: PropTypes.bool,
  userFullName: PropTypes.string,
  routeToJoin: PropTypes.func,
  routeToSignIn: PropTypes.func,
  signOut: PropTypes.func,
  routeToHome: PropTypes.func
};

MainHeader.defaultProps = {
  isLogged: false,
  userFullName: '',
  routeToJoin: () => {},
  routeToSignIn: () => {},
  signOut: () => {},
  routeToHome: () => {}
};

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/templates/MainHeader.js